const initialState :any= [];


const classNameReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_ClASS_NAME":
      return action?.payload;
      break;
    default:
      return state;
  }
};

export default classNameReducer;
